import MaterialFormControlLabel, {
    FormControlLabelProps,
} from '@mui/material/FormControlLabel';

export function FormControlLabel(props: FormControlLabelProps) {
    return (
        <MaterialFormControlLabel
            data-testid={'FormControlLabel-container'}
            {...props}
        />
    );
}

export default FormControlLabel;
